import { Breakdown } from "@xola/ui-kit";
import React from "react";
import { CatalogType, Experience, LineItem, PurchaseItem, UnitType } from "types";
import { getAddonColor, getPriceAndQuantity } from "./utils";
import { useResource } from "@/hooks/useResource";

interface AddonLineItemProps {
    lineItem: LineItem;
    item?: PurchaseItem;
    lineItemChoiceCatalogName?: string | null;
}

export const AddonLineItem = ({ lineItem, item, lineItemChoiceCatalogName }: AddonLineItemProps) => {
    return (
        <Breakdown.Item
            secondary={<PriceAndQuantity lineItem={lineItem} item={item} />}
            value={Math.abs(lineItem.amount)}
            color={getAddonColor(lineItem, item)}
            data-testid="addon-line-item"
            classNames={{ children: "no-translate", info: "no-translate" }}
        >
            {lineItemChoiceCatalogName && !lineItem.name?.includes(lineItemChoiceCatalogName)
                ? `${lineItemChoiceCatalogName}: `
                : ""}{" "}
            {lineItem.name}
        </Breakdown.Item>
    );
};

type PriceAndQuantityProps = Omit<AddonLineItemProps, "lineItemChoiceCatalogName">;

export const PriceAndQuantity = ({ lineItem, item }: PriceAndQuantityProps) => {
    const hasPriceAndQuantity = !!(lineItem.price && lineItem.quantity);

    const { data: experience } = useResource<Experience>(["experiences", item?.product.id], null, {
        enabled: !hasPriceAndQuantity && !!item?.product.id,
    });

    if (hasPriceAndQuantity) {
        return <>{getPriceAndQuantity(lineItem)}</>;
    }

    if (!experience) {
        return null;
    }

    const catalogItem = experience.catalog.items.find(
        (catalogItem) => catalogItem.template?.id === lineItem.template?.id,
    );

    if (!catalogItem || catalogItem.unitType !== UnitType.ADDON || catalogItem.type !== CatalogType.QUANTITY) {
        return null;
    }

    return <>{getPriceAndQuantity(lineItem)}</>;
};
